import { supabase } from './supabase';

// Generic file upload helper. Returns { publicUrl, path } or throws.
export async function uploadFile({ bucket = 'aksaaf-files', folder = 'misc', file, organizationId }) {
    if (!file) throw new Error('No file provided');
    const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
    const path = `${organizationId || 'shared'}/${folder}/${Date.now()}-${safeName}`;
    const { error } = await supabase.storage.from(bucket).upload(path, file, { upsert: true, cacheControl: '3600' });
    if (error) {
        if (error.message?.toLowerCase().includes('bucket') || error.statusCode === '404') {
            throw new Error(`Storage bucket "${bucket}" not found. Apply migration 0004_session2_storage.sql in Supabase.`);
        }
        throw error;
    }
    const { data: pub } = supabase.storage.from(bucket).getPublicUrl(path);
    return { publicUrl: pub.publicUrl, path };
}

export function fileNameFromUrl(url) {
    if (!url) return '';
    try {
        const u = new URL(url);
        const parts = u.pathname.split('/');
        return decodeURIComponent(parts[parts.length - 1] || '').replace(/^\d+-/, '');
    } catch { return ''; }
}
